import { Slot } from "radix-ui";
import type { ComponentProps } from "react";
import { tv, type VariantProps } from "tailwind-variants";

type ParagraphProps = ComponentProps<"p"> &
  VariantProps<typeof paragraphVariants> & {
    asChild?: boolean;
  };

const paragraphVariants = tv({
  base: "",
  variants: {
    variant: {
      error: "text-red-500",
    },
    size: {
      default: "",
      sm: "text-sm",
      lg: "text-lg",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const Paragraph = ({
  asChild,
  className,
  variant,
  size,
  ...props
}: ParagraphProps) => {
  if (!props.children) return null;

  const Component = asChild ? Slot.Root : "p";

  return (
    <Component
      className={paragraphVariants({ variant, size, className })}
      {...props}
    />
  );
};

Paragraph.displayName = "Paragraph";

export { Paragraph };
export type { ParagraphProps };
